import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { PROYECT, api_get, api_put } from "services/api";
import {
  getStations,
  orderCompaniesAndStations,
} from "helpers/companiesNormalized";
import { openSnackbar } from "./globalSnackbar";
import { UPDATE_UNIT_IMEI } from "redux/reducers/units_v2/unitsReducer";

// data
const LOAD_DATA_UNITS_SECTION = "LOAD_DATA_UNITS_SECTION";
const SET_DATA_UNITS_SECTION = "SET_DATA_UNITS_SECTION";
const CLEAR_DATA_UNITS_SECTION = "CLEAR_DATA_UNITS_SECTION";
const ERROR_DATA_UNITS_SECTION = "ERROR_DATA_UNITS_SECTION";

// units
const LOAD_UNITS_UNITS_SECTION = "LOAD_UNITS_UNITS_SECTION";
const SET_UNITS_UNITS_SECTION = "SET_UNITS_UNITS_SECTION";
const ERROR_UNITS_UNITS_SECTION = "ERROR_UNITS_UNITS_SECTION";

// units config
const SEND_UNIT_CONFIG_UNITS_SECTION = "SEND_UNIT_CONFIG_UNITS_SECTION";
const SET_UNIT_CONFIG_UNITS_SECTION = "SET_UNIT_CONFIG_UNITS_SECTION";
const ERROR_UNIT_CONFIG_UNITS_SECTION = "ERROR_UNIT_CONFIG_UNITS_SECTION";

// units imei
const SEND_IMEI_UNITS_SECTION = "SEND_IMEI_UNITS_SECTION";
const SET_IMEI_UNITS_SECTION = "SET_IMEI_UNITS_SECTION";
const SET_IMEI_DISPENSERS = "SET_IMEI_DISPENSERS";
const ERROR_IMEI_UNITS_SECTION = "ERROR_IMEI_UNITS_SECTION";

// filters
const CHANGE_COMPANY_UNITS_SECTION = "CHANGE_COMPANY_UNITS_SECTION";
const CHANGE_STATION_UNITS_SECTION = "CHANGE_STATION_UNITS_SECTION";

// config
const SET_CONFIG_TAB_UNITS_SECTION = "SET_CONFIG_TAB_UNITS_SECTION";
const SET_CONFIG_PAGE_TAGS_UNITS_SECTION = "SET_CONFIG_PAGE_TAGS_UNITS_SECTION";
const SET_CONFIG_PAGE_SIZE_TAGS_UNITS_SECTION =
  "SET_CONFIG_PAGE_SIZE_TAGS_UNITS_SECTION";
const SET_CONFIG_SORTED_TAGS_UNITS_SECTION =
  "SET_CONFIG_SORTED_TAGS_UNITS_SECTION";
const SET_CONFIG_FILTERED_TAGS_UNITS_SECTION =
  "SET_CONFIG_FILTERED_TAGS_UNITS_SECTION";

const CLEAR_ERROR_UNITS_SECTION = "CLEAR_ERROR_UNITS_SECTION";

const INITIAL_STATE = {
  brands: [],
  tags: [],
  companies: [],
  stations: [],
  units: [],
  configTypes: [],
  isLoading: false,
  error: false,
  errorMessage: "",
  isLoadingUnits: false,
  isLoadingUnitConfig: false,
  isLoadingImei: false,
  // filters
  companySelected: "",
  stationSelected: "",
  companyStations: [],
  // config
  config: {
    tab: 0,
    tags: {
      page: 0,
      pageSize: 50,
      sorted: [],
      filtered: [],
    },
  },
};

const unitsSectionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_UNITS_SECTION:
      return {
        ...state,
        brands: [],
        tags: [],
        companies: [],
        stations: [],
        isLoading: true,
        error: false,
        errorMessage: "",
      };
    case SET_DATA_UNITS_SECTION:
      return {
        ...state,
        brands: payload.brands,
        tags: payload.tags,
        companies: payload.companies,
        stations: payload.stations,
        isLoading: false,
      };
    case ERROR_DATA_UNITS_SECTION:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_DATA_UNITS_SECTION:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case LOAD_UNITS_UNITS_SECTION:
      return {
        ...state,
        units: [],
        configTypes: [],
        isLoadingUnits: true,
        error: false,
        errorMessage: "",
      };
    case SET_UNITS_UNITS_SECTION:
      return {
        ...state,
        units: payload.units.map(item => {
          return {
            ...item,
            tanks: item.tanks ? item.tanks : []
          }
        }),
        configTypes: payload.configTypes,
        tags: payload.tags,
        isLoadingUnits: false,
      };

      // case UPDATE_UNIT_TANKS:
      // const unitId = payload.id_unit
      // const unitTanks = payload.id_tanks

      // return {
      //     ...state,
      //     units: state.units.map(unit => {
      //       if(unit.id === unitId){
      //         return {
      //           ...unit,
      //           tanks: !unitTanks ? Object.values(payload).map(tank => tank.id_tank) : []
      //         }
      //       } else {
      //         return unit
      //       }
      //     })
      //   }
    case ERROR_UNITS_UNITS_SECTION:
      return {
        ...state,
        isLoadingUnits: false,
        error: true,
        errorMessage: payload.message,
      };
    case SEND_UNIT_CONFIG_UNITS_SECTION:
      return {
        ...state,
        isLoadingUnitConfig: true,
        error: false,
        errorMessage: "",
      };
    case SET_UNIT_CONFIG_UNITS_SECTION: {
      const { id } = payload.unit;
      const newUnits = [...state.units];
      const indexRow = newUnits.findIndex((unit) => unit.id === id);

      if (indexRow !== -1) {
        newUnits[indexRow] = payload.unit;
      }

      return {
        ...state,
        units: newUnits,
        isLoadingUnitConfig: false,
      };
    }
    case ERROR_UNIT_CONFIG_UNITS_SECTION:
      return {
        ...state,
        isLoadingUnitConfig: false,
        error: true,
        errorMessage: payload.message,
      };

    // imei
    case SEND_IMEI_UNITS_SECTION:
      return {
        ...state,
        isLoadingImei: true,
        error: false,
        errorMessage: "",
      };
    case SET_IMEI_UNITS_SECTION: {
      const { id } = payload.unit;
      const newUnits = [...state.units];

      const indexRow = newUnits.findIndex((unit) => unit.id === id);

      if (indexRow !== -1) {
        newUnits[indexRow].imei = payload.unit.imei;
      }

      return {
        ...state,
        units: newUnits,
        isLoadingImei: false,
      };
    }
    case SET_IMEI_DISPENSERS: {
      const { id } = payload.dispenser;
      const newUnits = [...state.units];

      const indexRow = newUnits.findIndex((unit) => unit.id === payload.idUnit);

      if (indexRow !== -1) {
        const dispenserRow = newUnits[indexRow].dispensers.findIndex(
          (dispenser) => dispenser.id === id
        );
        if (dispenserRow !== -1) {
          newUnits[indexRow].dispensers[dispenserRow].imei =
            payload.dispenser.imei;
        }
      }
      return {
        ...state,
        units: newUnits,
      };
    }
    case ERROR_IMEI_UNITS_SECTION:
      return {
        ...state,
        isLoadingImei: false,
        error: true,
        errorMessage: payload.message,
      };

    case CHANGE_COMPANY_UNITS_SECTION:
      return {
        ...state,
        companySelected: payload.company,
        companyStations: payload.stations,
      };
    case CHANGE_STATION_UNITS_SECTION:
      return {
        ...state,
        stationSelected: payload,
      };

    //config
    case SET_CONFIG_TAB_UNITS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tab: payload,
        },
      };
    case SET_CONFIG_FILTERED_TAGS_UNITS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tags: {
            ...state.config.tags,
            filtered: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_PAGE_TAGS_UNITS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tags: {
            ...state.config.tags,
            page: payload,
          },
        },
      };
    case SET_CONFIG_PAGE_SIZE_TAGS_UNITS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tags: {
            ...state.config.tags,
            pageSize: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_SORTED_TAGS_UNITS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tags: {
            ...state.config.tags,
            sorted: payload,
            page: 0,
          },
        },
      };

    case CLEAR_ERROR_UNITS_SECTION:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };

    default:
      return state;
  }
};

function getData() {
  return {
    type: LOAD_DATA_UNITS_SECTION,
  };
}

function getUnits(id) {
  return {
    type: LOAD_UNITS_UNITS_SECTION,
    payload: {
      id,
    },
  };
}

function sendUnitConfig(id, body) {
  return {
    type: SEND_UNIT_CONFIG_UNITS_SECTION,
    payload: {
      id,
      body,
    },
  };
}
function sendImeiAction(id, body) {
  return {
    type: SEND_IMEI_UNITS_SECTION,
    payload: {
      id,
      body,
    },
  };
}
function setUnitConfig(response) {
  return {
    type: SET_UNIT_CONFIG_UNITS_SECTION,
    payload: {
      unit: response,
    },
  };
}
function setImeiDispenser(dispenser, idUnit) {
  return {
    type: SET_IMEI_DISPENSERS,
    payload: {
      dispenser,
      idUnit,
    },
  };
}
function setConfigTab(tab) {
  return {
    type: SET_CONFIG_TAB_UNITS_SECTION,
    payload: tab,
  };
}
function setConfigTagsFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_TAGS_UNITS_SECTION,
    payload: filter,
  };
}
function setConfigTagsPage(page) {
  return {
    type: SET_CONFIG_PAGE_TAGS_UNITS_SECTION,
    payload: page,
  };
}
function setConfigTagsPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_TAGS_UNITS_SECTION,
    payload: pageSize,
  };
}
function setConfigTagsSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_TAGS_UNITS_SECTION,
    payload: sorted,
  };
}
function changeCompany(company, stations) {
  return {
    type: CHANGE_COMPANY_UNITS_SECTION,
    payload: { company, stations },
  };
}
function changeStation(station) {
  return {
    type: CHANGE_STATION_UNITS_SECTION,
    payload: station,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_UNITS_SECTION,
  };
}

function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  const urlBrands = `${process.env.REACT_APP_URL}${PROYECT}/brands`;
  const urlTags = `${process.env.REACT_APP_URL}${PROYECT}/tags`;
  try {
    const [companies, brands, tags] = yield all([
      call(api_get, urlCompanies, auth),
      call(api_get, urlBrands, auth),
      call(api_get, urlTags, auth),
    ]);

    const stations = getStations(companies.companies);
    const orderedCompanies = orderCompaniesAndStations(companies.companies);

    yield put({
      type: SET_DATA_UNITS_SECTION,
      payload: {
        companies: orderedCompanies,
        brands,
        stations,
        tags,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_UNITS_SECTION,
      payload: {
        message,
      },
    });
  }
}

function* fetchUnits(action) {
  const token = yield select((state) => state.login.token);
  const { tags } = yield select((state) => state.tagsReducer);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id },
  } = action;
  const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/units/conf?idStation=${id}`;
  try {
    const { types, units } = yield call(api_get, urlCompanies, auth);
    units.sort((act, next) => act.number.localeCompare(next.number));

    yield put({
      type: SET_UNITS_UNITS_SECTION,
      payload: {
        units: units,
        configTypes: types,
        tags: tags
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_UNITS_UNITS_SECTION,
      payload: {
        message,
      },
    });
  }
}
function* sendConfigUnit(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${id}/configuration`;
  try {
    const response = yield call(api_put, url, body, auth);

    yield put({
      type: SET_UNIT_CONFIG_UNITS_SECTION,
      payload: {
        unit: response,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_UNIT_CONFIG_UNITS_SECTION,
      payload: {
        message,
      },
    });
  }
}
function* sendImei(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${id}/user`;
  try {
    const response = yield call(api_put, url, body, auth);

    yield put({
      type: UPDATE_UNIT_IMEI,
      payload: {
        ...response
      },
    });
    yield put(openSnackbar("Cambio de IMEI éxitoso.", "success"));
  } catch (e) {
    const { data } = e.response;

    let error = "";
    if (e.response.status === 404) {
      error = "Error al enviar la petición.";
    } else {
      error = data ? data.message.error : "Error de datos";
    }
    yield put({
      type: ERROR_IMEI_UNITS_SECTION,
      payload: {
        message: error,
      },
    });
  }
}

function* unitsSectionSaga() {
  yield takeLatest(LOAD_DATA_UNITS_SECTION, fetchData);
  yield takeLatest(LOAD_UNITS_UNITS_SECTION, fetchUnits);
  yield takeLatest(SEND_UNIT_CONFIG_UNITS_SECTION, sendConfigUnit);
  yield takeLatest(SEND_IMEI_UNITS_SECTION, sendImei);
}

export {
  // reducer
  unitsSectionReducer,
  // actions
  getData,
  getUnits,
  sendUnitConfig,
  setUnitConfig,
  setImeiDispenser,
  sendImeiAction,
  setConfigTab,
  setConfigTagsFilter,
  setConfigTagsPage,
  setConfigTagsPageSize,
  setConfigTagsSorted,
  changeCompany,
  changeStation,
  clearError,
  //sagas
  unitsSectionSaga,
};